import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@icon/backlog-icon.svg'


const _hoisted_1 = { class: "label-pic is-teal" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "notification__update-item__initiator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ReferencedText = _resolveComponent("ReferencedText")!
  const _component_NotificationAttachmentFiles = _resolveComponent("NotificationAttachmentFiles")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    class: "notification__update-item"
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          fill: true,
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400"
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "link is-large",
            target: "_blank",
            href: _ctx.notification.itemUrl
          }, " Item " + _toDisplayString(_ctx.notification.itemSequenceNumber), 9, _hoisted_2),
          _createTextVNode(" Description has been updated by "),
          _createElementVNode("span", _hoisted_3, "@" + _toDisplayString(_ctx.notification.initiatorFullName), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400",
        className: "notification__update-item__content notification__update-item__description"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ReferencedText, {
            resetStyle: true,
            html: _ctx.getDescription()
          }, null, 8, ["html"])
        ]),
        _: 1
      }),
      (_ctx.notification.attachments.length)
        ? (_openBlock(), _createBlock(_component_NotificationAttachmentFiles, {
            key: 0,
            attachments: _ctx.notification.attachments,
            itemUrl: _ctx.notification.itemUrl,
            attachmentsCount: _ctx.notification.attachmentsCount
          }, null, 8, ["attachments", "itemUrl", "attachmentsCount"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["notification"]))
}